<div class="email-confirmation-reminder-container">
  <mat-icon
    class="material-symbols-outlined warning-icon"
    aria-hidden="true"
  >
    warning
  </mat-icon>
  <p class="mat-headline-medium reminder-text">
    Por favor, confirme seu e-mail para ter acesso às funcionalidades do Green Village
  </p>
</div>
